const dbp = new Promise((resolve, reject) => {
    const openreq = window.indexedDB.open("PH", 1);
    openreq.onerror = () => reject(openreq.error);
    openreq.onsuccess = () => resolve(openreq.result);
    openreq.onupgradeneeded = () => openreq.result.createObjectStore("statics");
});
const getDB = async (type) => {
    const db = await dbp;
    const transaction = db.transaction("statics", type);
    const store = transaction.objectStore("statics");
    return { store, transaction };
};
const call = async (request, transaction) => new Promise((resolve, reject) => {
    transaction.oncomplete = () => resolve(request);
    transaction.onabort = transaction.onerror = () => reject(transaction.error);
});
const get = async (key) => {
    try {
        const { store, transaction } = await getDB("readonly");
        const request = store.get(key);
        const { result } = (await call(request, transaction));
        return result;
    }
    catch {
        return undefined;
    }
};
const set = async (key, value) => {
    const { store, transaction } = await getDB("readwrite");
    const request = store.put({ data: value, timestamp: new Date().getTime() }, key);
    const data = await call(request, transaction);
    return data;
};
const remove = async (key) => {
    const { store, transaction } = await getDB("readwrite");
    const request = store.delete(key);
    const data = await call(request, transaction);
    return data;
};
export const indexedDB = { get, set, remove };
//# sourceMappingURL=idb.js.map